<template>
  <div class="app-header" :class="{scroll}">

    <div class="actions">
      <i class="menu-toggle material-icons" @click="toggleSidebar(true)" v-show="!showSidebar">menu</i>

      <i class="material-icons" @click="toggleSidebar(false)" v-show="showSidebar">close</i>

      <router-link to="/">
        <i class="logo icon-logo-horizontal"></i>
      </router-link>

      <i class="filter-toggle material-icons"
         :class="{active: active, hidden: showSidebar}"
         @click="toggleFilter"
      >
        filter_list
      </i>
    </div>

    <div class="bg visible-phone" :class="{active: active}" @click="toggleFilter"></div>

    <div class="content" :class="{active: active}">
      <div class="block numbers">
        <a v-for="(item, index) in numbers"
          :key="index"
          @click="handleNumber(item)"
          :class="{active: item === number}"
        >
          {{ item || 'All' }}
        </a>
      </div>

      <div class="block color select-dropdown" :class="{active: open === 1}" ref="focus" v-if="!simple">
        <div class="current" @click="toggle(1)" :class="{placeholder: colorFocus.placeholder}">
          <color-circle :color="colorFocus.color" v-if="colorFocus.color"/>
          <span class="text">
            {{ !colorFocus.placeholder ? colorFocus.text : 'Focus Color' }}
          </span>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>

        <color-dropdown :items="colorFocusItems" :onSelect="handleColorFocus"/>
      </div>

      <div class="block treatment select-dropdown" :class="{active: open === 2}" ref="range">
        <div class="current" @click="toggle(2)" :class="{placeholder: colorRange.placeholder}">
          <span class="text">
            {{ !colorRange.placeholder ? colorRange.text : 'Color Range' }}
          </span>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>

        <color-dropdown :items="colorRangeItems" :onSelect="handleColorRange" :hideColor="true"/>
      </div>

      <div class="block treatment select-dropdown" :class="{active: open === 3}" ref="feeling">
        <div class="current" @click="toggle(3)" :class="{placeholder: colorFeeling.placeholder}">
          <span class="text">
            {{ !colorFeeling.placeholder ? colorFeeling.text : 'Feeling' }}
          </span>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>

        <color-dropdown :items="colorFeelingItems" :onSelect="handleColorFeeling" :hideColor="true"/>
      </div>
      <div class="block filter" v-if="showClear">
        <a class="btn clear-filter primary" @click="clearFilter()">Clear</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { findAncestor } from '../utils/helper';
import ColorCircle from '../components/color/ColorCircle';
import ColorDropdown from '../components/color/ColorDropdown';

export default {
  components: {
    ColorDropdown,
    ColorCircle,
  },
  name: 'palette-header',
  props: {
    number: Number,
    numbers: Array,
    simple: Boolean,
    onNumber: Function,
    onColorFocus: Function,
    onColorRange: Function,
    onColorFeeling: Function,
    colorFocus: Object,
    colorRange: Object,
    colorFeeling: Object,
    clearFilter: Function,
    showClear: Boolean,
  },
  data() {
    return {
      active: false,
      scroll: false,
      open: 0,
      colorFocusItems: [
        {
          placeholder: true,
          color: null,
          text: 'Any color',
        },
        {
          color: '#FF0000',
          text: 'Red',
          hue_min: 15,
          hue_max: 330,
          reversed: true,
        },
        {
          color: '#FF7D00',
          text: 'Orange',
          hue_min: 16,
          hue_max: 45,
          reversed: false,
        },
        {
          color: '#FFFF00',
          text: 'Yellow',
          hue_min: 46,
          hue_max: 70,
          reversed: false,
        },
        {
          color: '#00FF00',
          text: 'Green',
          hue_min: 71,
          hue_max: 160,
          reversed: false,
        },
        {
          color: '#00FFFF',
          text: 'Cyan',
          hue_min: 161,
          hue_max: 200,
          reversed: false,
        },
        {
          color: '#0000FF',
          text: 'Blue',
          hue_min: 201,
          hue_max: 260,
          reversed: false,
        },
        {
          color: '#7D00FF',
          text: 'Violet',
          hue_min: 261,
          hue_max: 275,
          reversed: false,
        },
        {
          color: '#FF00FF',
          text: 'Magenta',
          hue_min: 276,
          hue_max: 315,
          reversed: false,
        },
        {
          color: '#FF007D',
          text: 'Rasberry',
          hue_min: 315,
          hue_max: 329,
          reversed: false,
        },
      ],
      colorRangeItems: [
        {
          placeholder: true,
          text: 'Any range',
        },
        {
          text: '1 Hue',
          value: 1,
        },
        {
          text: '2 Hues',
          value: 2,
        },
        {
          text: '3+ Hues',
          value: 3,
        },
      ],
      colorFeelingItems: [
        {
          placeholder: true,
          text: 'Any feeling',
        },
        {
          text: 'Muted',
          value: 'muted',
        },
        {
          text: 'Calming',
          value: 'calming',
        },
        {
          text: 'Bright',
          value: 'bright',
        },
      ],
    };
  },
  created() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('scroll', this.checkScroll);
  },
  computed: {
    ...mapState(['showSidebar']),
  },
  methods: {
    ...mapActions(['toggleSidebar']),
    toggle(id) {
      this.open = this.open === id ? 0 : id;
    },
    toggleFilter() {
      this.open = 0;
      this.active = !this.active;
    },
    handleNumber(item) {
      this.active = false;
      this.onNumber(item);
    },
    handleColorFocus(item) {
      this.open = 0;
      this.active = false;
      // this.colorFocus = item;
      this.onColorFocus(item);
    },
    handleColorRange(item) {
      this.open = 0;
      this.active = false;
      // this.colorRange = item;
      this.onColorRange(item);
    },
    handleColorFeeling(item) {
      this.open = 0;
      this.active = false;
      // this.colorFeeling = item;
      this.onColorFeeling(item);
    },
    clickEvent(e) {
      if (this.$refs.focus !== findAncestor(e.target, 'select-dropdown')
          && this.$refs.range !== findAncestor(e.target, 'select-dropdown')
          && this.$refs.feeling !== findAncestor(e.target, 'select-dropdown')) {
        this.open = 0;
      }
    },
    checkScroll() {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      this.scroll = top > 0;
    },
  },
  watch: {
    number(to) {
      if (to === 2) {
        this.colorRangeItems = [
          {
            placeholder: true,
            text: 'Any range',
          },
          {
            text: '1 Hue',
            value: 1,
          },
          {
            text: '2 Hues',
            value: 2,
          },
        ];
        if (this.colorRange.text === '3+ Hues') {
          this.onColorRange(this.colorRangeItems[2]);
        }
      } else {
        this.colorRangeItems = [
          {
            placeholder: true,
            text: 'Any range',
          },
          {
            text: '1 Hue',
            value: 1,
          },
          {
            text: '2 Hues',
            value: 2,
          },
          {
            text: '3+ Hues',
            value: 3,
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/header';

  .numbers {
    padding: 0 15px;

    a {
      padding: 14px;
      color: $gray;

      &:hover, &.active {
        color: $dark;
      }
    }
  }

  .block.filter {
    background: $bg2;
    text-align: center;
  }

  .clear-filter {
    padding: 5px 10px;
    border-radius: 40px;
    text-transform: uppercase;
    font-size: 12px;
  }
</style>
